export type AppThemeId = 'default' | 'dark' | 'copa' | 'rosa' | 'usa';

export interface AppThemeOption {
  id: AppThemeId;
  label: string;
  description: string;
  available: boolean;
}

/** Temas disponíveis — Padrão = claro */
export const APP_THEME_OPTIONS: AppThemeOption[] = [
  {
    id: 'default',
    label: 'Padrão',
    description: 'Interface clara',
    available: true,
  },
  {
    id: 'dark',
    label: 'Escuro',
    description: 'Interface com fundo escuro',
    available: true,
  },
  {
    id: 'copa',
    label: 'Copa do Mundo',
    description: 'Verde e amarelo — Brasil 2026',
    available: true,
  },
  {
    id: 'rosa',
    label: 'Rosa',
    description: 'Interface clara com tons de rosa',
    available: true,
  },
  {
    id: 'usa',
    label: 'Azul Escuro',
    description: 'Vermelho, branco e azul',
    available: true,
  },
];

export const FUTURE_THEME_OPTIONS: AppThemeOption[] = [];

export const ALL_THEME_OPTIONS: AppThemeOption[] = [
  ...APP_THEME_OPTIONS,
  ...FUTURE_THEME_OPTIONS,
];

export const THEME_STORAGE_KEY = 'sysup-theme-id';

export function isAppThemeId(value: string | null): value is AppThemeId {
  return value === 'default' || value === 'dark' || value === 'copa' || value === 'rosa' || value === 'usa';
}

export function readStoredThemeId(): AppThemeId {
  const savedId = localStorage.getItem(THEME_STORAGE_KEY);

  if (savedId === 'light') return 'default';
  if (isAppThemeId(savedId)) return savedId;

  const legacy = localStorage.getItem('sysup-theme');
  if (legacy === 'dark') return 'dark';
  if (legacy === 'copa') return 'copa';
  if (legacy === 'rosa') return 'rosa';
  if (legacy === 'usa') return 'usa';

  return 'default';
}

export function resolveIsDarkMode(themeId: AppThemeId): boolean {
  return themeId === 'dark';
}

export function getBodyThemeClass(themeId: AppThemeId): string {
  if (themeId === 'dark') return 'dark-theme';
  return 'light-theme';
}

export function persistLegacyThemeKey(themeId: AppThemeId): string {
  if (themeId === 'dark') return 'dark';
  if (themeId === 'copa') return 'copa';
  if (themeId === 'rosa') return 'rosa';
  if (themeId === 'usa') return 'usa';
  return 'light';
}

export function isCopaTheme(themeId: AppThemeId): boolean {
  return themeId === 'copa';
}

export function isRosaTheme(themeId: AppThemeId): boolean {
  return themeId === 'rosa';
}

export function isUsaTheme(themeId: AppThemeId): boolean {
  return themeId === 'usa';
}

export function isLightTheme(themeId: AppThemeId): boolean {
  return themeId === 'default' || themeId === 'copa' || themeId === 'rosa' || themeId === 'usa';
}
